import { API } from 'aws-amplify';
import * as constantes from './constantes';
import * as excepciones from './excepciones';
import * as iotPubsub from './iot-pubsub';
import * as notificadores from './notificadores';

const WORKER_FILE_PATH = '/service-workers/notificaciones.js';
const NOTIFICACIONES_API_NAME = 'notificaciones';
const NOTIFICACIONES_TOPICO_URL = '/notificaciones/topico';

const SubscriptionInstance = iotPubsub.SubscriptionManager();

// https://medium.com/izettle-engineering/beginners-guide-to-web-push-notifications-using-service-workers-cb3474a17679

const suscribirTopico = function(region, endPoint, topic, notificador) {
	let nextFun = function(rawData) {
		// Recibir datos de notificación
		let value = rawData.value;
		let mensaje = `${value.data.mensaje}`;
		let destinatario = value.destinatario;
		let titulo = `e-Boleta ${destinatario}`;
		console.log(rawData)
		
		// Mostrar notificación
		notificador.notificar(titulo, mensaje);
	};
	let errorFun = function(error) {
		// Nada
	};
	let closeFun = function() {
		// Nada
	};
	
	SubscriptionInstance.subscribe(topic, nextFun, errorFun, closeFun, region, endPoint);
};

const obtenerDatosIot = async function() {
	let response;
	
	try {
		// Desde API de notificaciones, obtener la configuración para suscribir y nombre tópico propio del usuario
		response = await API.get(NOTIFICACIONES_API_NAME, NOTIFICACIONES_TOPICO_URL);
	}
	catch(e) {
		throw new excepciones.ErrorDatosIoT();
	}
	
	let datos = {
		'topic': response.topicName,
		'region': response.iot.region,
		'endPoint': response.iot.pubSubEndpointUrl,
	};
	
	return datos;
};

const solicitarPermiso = async function() {
	let respuesta = await window.Notification.requestPermission();
	
	if(respuesta !== constantes.GRANTED) {
		throw new excepciones.RechazoNotificaciones();
	}
};

const registrarServiceWorker = async function() {
	let registroServiceWorker;
	try {
		registroServiceWorker = await window.navigator.serviceWorker.register(WORKER_FILE_PATH);
	}
	catch(e) {
		throw new excepciones.ErrorRegistroServiceWorker();
	}
	
	return registroServiceWorker;
};

export const suscribir = async function() {
	try {
		
		let notificador;
		let windowTieneAndroid = notificadores.NotificadorAppEBoletaAndroid.windowTieneAndroid();
		
		if(windowTieneAndroid) {
			// Se está ejecutando dentro de la App e-Boleta (Webview en Android)
			notificador = new notificadores.NotificadorAppEBoletaAndroid();
		}
		else {
			// Solicitar permiso para mostrar notificaciones. Si no se acepta, lanzará excepción.
			await solicitarPermiso();
			
			// Obtener registro de ServiceWorker.
			let registroServiceWorker = await registrarServiceWorker();
			notificador = new notificadores.NotificadorServiceWorker(registroServiceWorker);
		}
		
		// Obtener datos para suscribirse a notificaciones.
		
		let datosIot = await obtenerDatosIot();
		return;

		const region = datosIot.region;
		const endPoint = datosIot.endPoint;
		const topic = datosIot.topic;
		
		suscribirTopico(region, endPoint, topic, notificador);
	}
	catch(e) {
		// Nada que hacer
	}
};

export const desuscribir = function() {
	SubscriptionInstance.unsubscribe();
};
